export default __webpack_public_path__ + "static/media/onboardingLogo.f03e29e4.png";